import { focusedElementBeforeMenu, mobileMenu, menuOverlay, menuToggles } from './mobileMenu/_vars'
import openMenu from './mobileMenu/openMenu'

/**
 * Create click listeners for buttons that open the menu.
 */
const handleMobileMenu = () => {
  if ( menuToggles && mobileMenu && menuOverlay )
    menuToggles.forEach( menuToggle =>
      menuToggle.addEventListener( 'click', () => {
        openMenu( focusedElementBeforeMenu, mobileMenu, menuOverlay, menuToggle )
      } )
    )
    const offCanvasMenu = document.getElementById( 'mobile-menu' )
    if( offCanvasMenu ) {
      // console.log( offCanvasMenu )
      const menuOffcanvasItems = offCanvasMenu.querySelectorAll( 'li' )
      menuOffcanvasItems.forEach( menuItem => {
        // console.log( menuItem )
        const submenu = menuItem.querySelector<HTMLElement>( '.submenu-column' )
        const button = menuItem.querySelector( 'button' )
        menuItem.addEventListener( 'click', () => {
          console.log( 'click' )
          if ( submenu ) {
            if( submenu.style.height === '0px' ) {
              if ( button ) button.setAttribute( 'aria-expanded', 'true' )
              submenu.classList.remove( 'menu-hidden' )
              submenu.classList.add( 'menu-revealed' )
              submenu.style.height = '100%'
              submenu.style.opacity = '1'
            } else {
              submenu.style.height = '0px'
              submenu.style.opacity = '0'
              submenu.classList.add( 'menu-hidden' )
              submenu.classList.remove( 'menu-revealed' )
              if ( button ) button.setAttribute( 'aria-expanded', 'false' )
            }
          }
        } )
        
      } )
    }
    
}

export default handleMobileMenu
